import { render } from "./SimpleDashboardCard.vue?vue&type=template&id=b8ae78b8&ts=true"
import script from "./SimpleDashboardCard.vue?vue&type=script&lang=ts"
export * from "./SimpleDashboardCard.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__